import { TimeoutException } from './exceptions'

export function getNullPromise(): Promise<void> {
  return new Promise((resolve) => {
    resolve()
  })
}

export function wait(timeMs: number): Promise<void> {
  return new Promise((resolve) => {
    setTimeout(resolve, timeMs)
  })
}

export async function throwIfTimeout(
  message: string,
  timeMs: number,
): Promise<void> {
  await wait(timeMs)
  throw new TimeoutException(message)
}

export async function resolvePromisesInObject(
  object: Record<string, any>,
): Promise<Record<string, any>> {
  // Loop over keys, chaining promises to write their values to the return object
  const awaitedObject = {}
  Object.entries(object).forEach(([key, value]) => {
    if (value instanceof Promise) {
      value.then((resolvedValue) => {
        awaitedObject[key] = resolvedValue
      })
    } else {
      awaitedObject[key] = value
    }
  })

  // Wait for all promises to resolve (don't need to filter out non-promises)
  await Promise.all(Object.values(object))

  // Return the resulting object
  return awaitedObject
}
